import Reveal from '@/components/base/Reveal';
import { testimonials } from '@/mocks/results';

export default function TestimonialsSection() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            In Their Words
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            What Clients Say About Working With Josh
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 3).map((t, i) => (
            <Reveal key={t.name} delay={i * 80}>
              <div className="flex h-full flex-col rounded-2xl border border-white/8 bg-background-100 p-7">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                  <i className="ri-double-quotes-l text-lg"></i>
                </span>
                <p className="mt-5 text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="mt-auto pt-6">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                    <i className="ri-award-line"></i>
                    {t.tag}
                  </span>
                  <div className="mt-4">
                    <p className="font-heading font-semibold text-sm text-foreground-950">
                      {t.name}
                    </p>
                    <p className="text-xs text-foreground-600">
                      {t.business} · {t.industry}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {testimonials.length > 3 && (
          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
            {testimonials.slice(3).map((t, i) => (
              <Reveal key={t.name} delay={i * 80}>
                <div className="flex flex-col rounded-2xl border border-white/8 bg-background-100/60 p-6">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <div className="mt-4 flex items-center justify-between">
                    <div>
                      <p className="font-heading font-semibold text-sm text-foreground-950">
                        {t.name}
                      </p>
                      <p className="text-xs text-foreground-600">
                        {t.industry}
                      </p>
                    </div>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                      {t.tag}
                    </span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
